module.exports = {
	"config": {
		"siteTitle": "Thomas Koefod",
		"linkPrefix": "/gatsby-starter-default"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "aboutMe.md",
				"ext": "md",
				"name": "aboutMe",
				"extname": ".md",
				"basename": "aboutMe.md",
				"dirname": "",
				"stem": "aboutMe",
				"path": "aboutMe.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/aboutMe.md",
				"isAbsolute": false
			},
			"requirePath": "aboutMe.md",
			"path": "/aboutMe/",
			"data": {
				"title": "About me"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "apps.md",
				"ext": "md",
				"name": "apps",
				"extname": ".md",
				"basename": "apps.md",
				"dirname": "",
				"stem": "apps",
				"path": "apps.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/apps.md",
				"isAbsolute": false
			},
			"requirePath": "apps.md",
			"path": "/apps/",
			"data": {
				"title": "Apps"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "blog",
				"stem": "_template",
				"path": "blog/_template.jsx",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/blog/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "blog/_template.jsx",
			"templatePath": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "20170201.md",
				"ext": "md",
				"name": "20170201",
				"extname": ".md",
				"basename": "20170201.md",
				"dirname": "blog",
				"stem": "20170201",
				"path": "blog/20170201.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/blog/20170201.md",
				"isAbsolute": false
			},
			"requirePath": "blog/20170201.md",
			"path": "/blog/20170201/",
			"data": {
				"title": "redesign"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "flex.md",
				"ext": "md",
				"name": "flex",
				"extname": ".md",
				"basename": "flex.md",
				"dirname": "blog",
				"stem": "flex",
				"path": "blog/flex.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/blog/flex.md",
				"isAbsolute": false
			},
			"requirePath": "blog/flex.md",
			"path": "/blog/flex/",
			"data": {
				"title": "flex quick reference"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "gettingStartedWithGatsby.md",
				"ext": "md",
				"name": "gettingStartedWithGatsby",
				"extname": ".md",
				"basename": "gettingStartedWithGatsby.md",
				"dirname": "blog",
				"stem": "gettingStartedWithGatsby",
				"path": "blog/gettingStartedWithGatsby.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/blog/gettingStartedWithGatsby.md",
				"isAbsolute": false
			},
			"requirePath": "blog/gettingStartedWithGatsby.md",
			"path": "/blog/gettingStartedWithGatsby/",
			"data": {
				"title": "Getting Started with Gatsby"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "blog",
				"stem": "index",
				"path": "blog/index.js",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/blog/index.js",
				"isAbsolute": false
			},
			"requirePath": "blog/index.js",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "tmuxCheat.md",
				"ext": "md",
				"name": "tmuxCheat",
				"extname": ".md",
				"basename": "tmuxCheat.md",
				"dirname": "blog",
				"stem": "tmuxCheat",
				"path": "blog/tmuxCheat.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/blog/tmuxCheat.md",
				"isAbsolute": false
			},
			"requirePath": "blog/tmuxCheat.md",
			"path": "/blog/tmuxCheat/",
			"data": {
				"title": "tmux cheat sheet"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "contacts.js",
				"ext": "js",
				"name": "contacts",
				"extname": ".js",
				"basename": "contacts.js",
				"dirname": "",
				"stem": "contacts",
				"path": "contacts.js",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/contacts.js",
				"isAbsolute": false
			},
			"requirePath": "contacts.js",
			"path": "/contacts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "links.md",
				"ext": "md",
				"name": "links",
				"extname": ".md",
				"basename": "links.md",
				"dirname": "",
				"stem": "links",
				"path": "links.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/links.md",
				"isAbsolute": false
			},
			"requirePath": "links.md",
			"path": "/links/",
			"data": {
				"title": "Links"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "podcasts.md",
				"ext": "md",
				"name": "podcasts",
				"extname": ".md",
				"basename": "podcasts.md",
				"dirname": "",
				"stem": "podcasts",
				"path": "podcasts.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/podcasts.md",
				"isAbsolute": false
			},
			"requirePath": "podcasts.md",
			"path": "/podcasts/",
			"data": {
				"title": "Podcasts I listen to regularly"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "testPage.md",
				"ext": "md",
				"name": "testPage",
				"extname": ".md",
				"basename": "testPage.md",
				"dirname": "",
				"stem": "testPage",
				"path": "testPage.md",
				"absolute": "/Users/tkoefod1/Repositories/gatsby-thomaskoefodcom/testPage.md",
				"isAbsolute": false
			},
			"requirePath": "testPage.md",
			"path": "/testPage/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0